import { request } from '@/util/request'
/**
 * @name MobileRefund
 * @desc 移动端根据工号与姓名获取机构信息
 * @params {object} data
 * @param {string} data.amount 金额
 * @param {string} data.refundPersonId 退保人员id 
 * @param {string} data.insuranceId 保单id
 * @param {string} data.appntMobileNumber 投保人手机号
 * @param {string} data.captcha 验证码

 联系人
 * */
export function MobileRefund(data = {}, loadingConfig) {
 return request({
   url: `${process.env.VUE_APP_API_PATH}/services/front/paymentResource/paymentRefund`,
   method: 'post',
   data,
   loadingConfig
 })
}